export const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || "393807591108";
export const WHATSAPP_MESSAGE = process.env.REACT_APP_WHATSAPP_MESSAGE ||
  "Ciao Kaós! Vorrei assistenza nella scelta di un prodotto.";
export const INSTAGRAM_URL = process.env.REACT_APP_INSTAGRAM_URL || "https://www.instagram.com/kaosluxurycosmetics/";
export const FACEBOOK_URL = process.env.REACT_APP_FACEBOOK_URL || "https://www.facebook.com/kaosluxurycosmetics/";
export const YOUTUBE_URL = process.env.REACT_APP_YOUTUBE_URL || "";
export const CONTACT_EMAIL = process.env.REACT_APP_CONTACT_EMAIL || "infokaosluxurycosmetics@gmail.com";
export const WHATSAPP_CATALOG_URL = "https://wa.me/c/393807591108";

export const whatsappLink = () =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

export const qrTarget = () =>
  typeof window !== "undefined" ? window.location.origin : "https://kaoscosmetics.com";

// Home videos (muted / autoplay / loop). They can be overridden from the environment.
export const HERO_VIDEO = process.env.REACT_APP_HERO_VIDEO_URL || "";
export const BRAND_VIDEO = process.env.REACT_APP_BRAND_VIDEO_URL || "";
const DEFAULT_HOME_VIDEOS = [
  "/media/home-preview-9683.mp4",
  "/media/home-preview-9686.mp4",
  "/media/home-preview-9576-upright.mp4",
];
const CONFIGURED_HOME_VIDEOS = (process.env.REACT_APP_HOME_VIDEO_URLS || HERO_VIDEO || "")
  .split(",")
  .map((url) => url.trim())
  .filter(Boolean);
export const HOME_VIDEOS = [
  ...CONFIGURED_HOME_VIDEOS,
  ...DEFAULT_HOME_VIDEOS.slice(CONFIGURED_HOME_VIDEOS.length),
].slice(0, DEFAULT_HOME_VIDEOS.length);
